var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSyngenta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 343,
    height: 142,
    viewBox: "0 0 343 142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1582",
    "data-name": "Ret\\xE2ngulo 1582",
    width: 343,
    height: 142,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-logo_fundo_azul"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 142
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_fundo_azul",
    "data-name": "logo fundo azul",
    clipPath: "url(#clip-logo_fundo_azul)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_de_m\\xE1scara_2",
    "data-name": "Grupo de m\\xE1scara 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_670",
    "data-name": "Caminho 670",
    d: "M1582-16s-146,32-48,126,560-46,560-46L1912-110Z",
    transform: "matrix(-0.951, -0.309, 0.309, -0.951, 1750.207, 613.232)",
    fill: "#21aac8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-1319.079 -413.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g48700",
    transform: "translate(1366.76 448.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path48290",
    d: "M1999.249,512.431h-6.205v10.253c0,2.923,1.544,3.467,3.536,3.467a16.631,16.631,0,0,0,2.187-.2l.482,4.6a34.282,34.282,0,0,1-5.209.536c-4.261,0-8.055-1.492-8.055-6.731V512.431H1982.4V507.9h3.585v-4.992l7.059-2V507.9h6.205v4.531",
    transform: "translate(-1838.412 -488.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48292",
    d: "M1901.816,551.783h-7.059V537.2c0-2.147-.9-3.333-3.328-3.333-1.831,0-3.005.881-4.324,1.932v15.981h-7.075v-22.71h6.867v2a13.922,13.922,0,0,1,7.8-2.529c4.5,0,7.122,2.794,7.122,7.057v16.182",
    transform: "translate(-1759.985 -509.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48294",
    d: "M1756.505,448.171c-3.585,6.052-2.025,11.534-5.531,15.027-2.8,2.809-5.4,2.714-8.457,2.714-1.076,0-3.134.095-4,.722a17.121,17.121,0,0,1-.725-5.036,9.967,9.967,0,0,1,2.718-7.51c3.971-3.967,11.158-5.226,16-5.917",
    transform: "translate(-1651.012 -448.171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48296",
    d: "M1582.812,551.783h-7.059V537.2c0-2.147-.9-3.333-3.328-3.333-1.817,0-3.007.881-4.327,1.932v15.981h-7.058v-22.71h6.867v2a13.912,13.912,0,0,1,7.781-2.529c4.5,0,7.124,2.794,7.124,7.057v16.182",
    transform: "translate(-1515.601 -509.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48298",
    d: "M1469.429,530.8l-11.32,27.51c-1.735,4.224-5.225,7.326-9.984,7.326a19.852,19.852,0,0,1-5.194-.664l1-4.533a13.945,13.945,0,0,0,3.054.4c2.846,0,4.358-2.413,5.74-5.727l.66-1.6-8.794-22.71h7.587l4.133,11.257a30.07,30.07,0,0,1,1.013,3.729c.257-.986.755-2.621,1.256-3.928l4.259-11.057h6.593",
    transform: "translate(-1425.115 -511.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48300",
    d: "M1386.135,543.208c0,4.944-4.565,7.66-9.984,7.66a23.963,23.963,0,0,1-9.39-1.8l1.929-4.6a19.112,19.112,0,0,0,6.465,1.531c1.639,0,3.922-.2,3.922-2.2,0-.934-.578-1.415-1.672-1.732-1.349-.4-3.424-.757-4.79-1.132-2.879-.794-5.258-2.306-5.258-6.528,0-4.682,3.988-7.593,9.454-7.593a26.317,26.317,0,0,1,7.926,1.066l-1.8,4.6a16.116,16.116,0,0,0-5.192-1c-1.946,0-3.265.741-3.265,1.933a1.8,1.8,0,0,0,1.4,1.666c1.111.354,2.863.675,4.324,1,3.024.661,5.934,2.388,5.934,7.126",
    transform: "translate(-1366.76 -508.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48302",
    d: "M2073.186,545.724v-4.2c-3.262-.055-6.333.275-6.333,3.4,0,1.933,1.639,2.534,2.877,2.534A4.513,4.513,0,0,0,2073.186,545.724Zm6.851,6.059h-6.656v-1.794a9.509,9.509,0,0,1-6.448,2.266c-4.229,0-7.122-2.047-7.122-6.329,0-7.528,7.508-8.7,13.376-8.723v-.6c0-1.867-.706-3.2-4.051-3.2a13.986,13.986,0,0,0-6.528,2.134l-1.738-4.2a22.338,22.338,0,0,1,10.242-2.794c5.419,0,8.925,2.587,8.925,7.125v16.114",
    transform: "translate(-1897.717 -509.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48310",
    d: "M1785.275,537.4c.129-2.5-1.125-4.063-3.585-4.063-2.379,0-3.794,1.748-4.2,4.063Zm7.269,2.2c0,.747-.016,1.527-.066,2.33h-15.05c.066,3.3,1.7,5.263,6.53,5.263a11.93,11.93,0,0,0,5.789-1.733l1.864,4.2a20.89,20.89,0,0,1-10.195,2.6c-7.059,0-11.446-4.547-11.446-11.792a11.7,11.7,0,0,1,11.977-11.917c7.767,0,10.6,4.528,10.6,11.054",
    transform: "translate(-1675.666 -509.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48312",
    d: "M1682.08,555.289c0-1.854-1.478-2.532-2.989-2.532H1672.9c-.95.537-2.395,1.722-2.395,3.266,0,1.992,2.685,3.328,5.852,3.328C1679.652,559.351,1682.08,557.839,1682.08,555.289Zm-1.864-19.516a3.166,3.166,0,0,0-3.394-3.463,3.476,3.476,0,0,0-3.457,3.463,3.223,3.223,0,0,0,3.328,3.463A3.269,3.269,0,0,0,1680.216,535.773Zm8.939,18.584c0,6.624-6.607,9.691-13.119,9.726-5.742.026-11.257-1.622-11.257-7.129,0-2.574,2.269-4.3,3.651-5.2a7.358,7.358,0,0,1-2.058-1.463,5.069,5.069,0,0,1-1.141-3.534c0-2.216,1.96-4.271,4.341-5.592-1.319-.693-3.071-1.806-3.071-5.53,0-4.84,4.6-7.391,10.595-7.391,5.1,0,9.987,1.219,9.987,7.194,0,5.706-5.356,7.787-10.789,7.787a14.146,14.146,0,0,1-2.8-.328c-.578.309-1.736,1.072-1.736,1.931,0,1.745,2.379,2,3.474,2h5.594c5.178,0,8.329,2.515,8.329,7.525",
    transform: "translate(-1595.078 -509.519)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSyngenta);
export default __webpack_public_path__ + "static/media/logoSyngenta.dd45543a4a65207bb64e93102d61ef81.svg";
export { ForwardRef as ReactComponent };